import { SHAPE_OBJECT_TYPES, type Style } from "@bezpart-board/shared";

export type StrokeStylePartial = Pick<Style, "stroke" | "strokeWidth" | "strokeDash">;

const STROKE_OBJECT_TYPES = new Set<string>(["path", "line", "arrow", ...SHAPE_OBJECT_TYPES]);
const FILL_OBJECT_TYPES = new Set<string>(["frame", ...SHAPE_OBJECT_TYPES]);

export function supportsStrokeStyle(type: string | null): boolean {
  return type !== null && STROKE_OBJECT_TYPES.has(type);
}

export function supportsFillStyle(type: string | null): boolean {
  return type !== null && FILL_OBJECT_TYPES.has(type);
}

export function buildStrokeStylePatch(partial: StrokeStylePartial): Record<string, unknown> {
  const style: Record<string, unknown> = {};
  if (partial.stroke !== undefined) style.stroke = partial.stroke;
  if (partial.strokeWidth !== undefined) style.strokeWidth = partial.strokeWidth;
  if (partial.strokeDash !== undefined) style.strokeDash = partial.strokeDash;
  return { style };
}

/** style.fill + legacy flat fill для API и старых объектов. */
export function buildFillStylePatch(fill: string): Record<string, unknown> {
  return { style: { fill }, fill };
}
